import { render, staticRenderFns } from "./VModalConnectWallet.vue?vue&type=template&id=5bbd015e&scoped=true&"
import script from "./VModalConnectWallet.vue?vue&type=script&lang=js&"
export * from "./VModalConnectWallet.vue?vue&type=script&lang=js&"
import style0 from "./VModalConnectWallet.vue?vue&type=style&index=0&id=5bbd015e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbd015e",
  null
  
)

export default component.exports